import { render, staticRenderFns } from "./OutdatedClientModal.vue?vue&type=template&id=073e0b29&scoped=true&"
import script from "./OutdatedClientModal.vue?vue&type=script&lang=js&"
export * from "./OutdatedClientModal.vue?vue&type=script&lang=js&"
import style0 from "./OutdatedClientModal.vue?vue&type=style&index=0&id=073e0b29&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "073e0b29",
  null
  
)

export default component.exports